import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Button, Icon, Modal, Grid, Input, Dropdown} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {getDropdownOptions} from '../../../../common/util/dropdown';
import {isString} from 'lodash';

const {
  changeWtsAgencySelected,
  createWtsAgency,
  updateWtsAgency,
  getWtsAgencies,
  getWtsEmployeesGestor,
  getWtsEmployeesEvaluator,
} = Actions;

const WtsAgencyModal = ({mode, agencyToEdit}) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const wtsAgenciesList = useSelector((state) => state.wtsAgencies.agencies);
  const wtsCoursesAreas = useSelector((state) => state.wtsDealer.dealers);
  const areaSelected = useSelector((state) => state.wtsAreas.areaSelected);
  const agencySelected = useSelector((state) => state.wtsAgencies.agenciesSelected);
  const wtsEmployeesGestor = useSelector((state) => state.wtsEmployees.employeesGestor);
  const wtsEmployeesEvaluator = useSelector((state) => state.wtsEmployees.employeesEvaluator);

  const generateNextAgencyId = (ruc) => {
    const dealer = wtsCoursesAreas.find((d) => d.ruc === ruc);
    if (!dealer || !dealer.code) {
      return '';
    }

    const dealerCode = dealer.code.trim();
    const relatedAgencies = wtsAgenciesList.filter((a) => a.id && a.id.startsWith(`${dealerCode}-`));

    let maxNumber = 0;
    relatedAgencies.forEach((agency) => {
      const parts = agency.id.split('-');
      const num = parseInt(parts[parts.length - 1], 10);
      if (!isNaN(num) && num > maxNumber) {
        maxNumber = num;
      }
    });

    return `${dealerCode}-${maxNumber + 1}`;
  };

  const onChangeValues = (value, field) => {
    let newId = agencySelected?.id || '';

    if (field === 'ruc' && mode === 'new') {
      newId = generateNextAgencyId(value);
      dispatch(getWtsEmployeesGestor(areaSelected.id, 'GESTOR', value));
      dispatch(getWtsEmployeesEvaluator(areaSelected.id, 'EVALUADOR', value));
    }

    const changedSkillSelected = {
      ...agencySelected,
      [field]: isString(value) ? value.toUpperCase() : value,
      'id': newId,
    };

    dispatch(changeWtsAgencySelected(changedSkillSelected));
  };

  const showCourseStatusModal = (e, value) => {
    e.preventDefault();
    setShowModal(value);
    if (value && mode === 'edit') {
      dispatch(getWtsEmployeesGestor(areaSelected.id, 'GESTOR', agencyToEdit.ruc));
      dispatch(getWtsEmployeesEvaluator(areaSelected.id, 'EVALUADOR', agencyToEdit.ruc));
      dispatch(changeWtsAgencySelected({
        ...agencyToEdit,
        'gestorCode': agencyToEdit.gestorCode,
        'evaluator': agencyToEdit.evaluator,
      }));
    } else if (value && mode === 'new') {
      dispatch(changeWtsAgencySelected(null));
    }
  };

  const saveCourseArea = async(e) => {
    e.preventDefault();
    if (mode === 'new') {
      dispatch(createWtsAgency(areaSelected.id, {'data': agencySelected}));
    } else {
      dispatch(updateWtsAgency(areaSelected.id, {'data': agencySelected}));
    }
    dispatch(getWtsAgencies(areaSelected.id));
    setShowModal(false);
  };

  return (
    <Modal size='tiny' closeOnEscape={false} closeOnDimmerClick={false}
      open={showModal}
      trigger={
        mode === 'new' ?
          <Button compact content="Añadir"
            icon={<Icon name='add-circle' size='big' color='green' />}
            onClick={(e) => showCourseStatusModal(e, true)} /> :
          <Icon link name='pencil' size='big' onClick={(e) => showCourseStatusModal(e, true)} color='green' />
      }>
      <Modal.Header>
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>
            {mode === 'new' ? 'Crear Agencia' : 'Editar Agencia'}
          </h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => showCourseStatusModal(e, false)} />
        </div>
      </Modal.Header>
      <Modal.Content>
        <Grid stackable stretched>
          <Grid.Row>
            <Grid.Column>
              <label>Concesionario</label>
              <Dropdown fluid selection labeled className='labeled-dropdown'
                value={agencySelected?.ruc || ''}
                onChange={(e, i) => onChangeValues(i.value, 'ruc')}
                options={getDropdownOptions(wtsCoursesAreas, 'ruc', 'description') || []}
                disabled={mode !== 'new'} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Input fluid
                label="Código Agencia"
                value={agencySelected?.id || ''}
                disabled={true}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Input fluid
                label="Nombre Agencia"
                value={agencySelected?.description || ''}
                onChange={(e, {value}) => onChangeValues(value, 'description')}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <label>Gestor</label>
              <Dropdown fluid selection labeled className='labeled-dropdown'
                value={agencySelected?.gestorCode || ''}
                onChange={(e, i) => onChangeValues(i.value, 'gestorCode')}
                options={getDropdownOptions(wtsEmployeesGestor, 'id', 'fullName') || []} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <label>Evaluador</label>
              <Dropdown fluid selection labeled className='labeled-dropdown'
                value={agencySelected?.evaluator || ''}
                onChange={(e, i) => onChangeValues(i.value, 'evaluator')}
                options={getDropdownOptions(wtsEmployeesEvaluator, 'id', 'fullName') || []} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button positive compact icon='save' onClick={(e) => saveCourseArea(e)}>Guardar</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default WtsAgencyModal;
